import { DrawerBody, DrawerHeader } from "@chakra-ui/modal";
import UserForm from "./user-form";

const NewUser = (props) => {
    const {onClose} = props;
    return (
        <>
            <DrawerHeader className="px-[32px] pt-6">
                <div className="font-bold text-xl text-gray-800 dark:text-white">
                    Create user
                </div>
            </DrawerHeader>
            <DrawerBody className="flex-1 px-[32px] my-6 overflow-auto">
                <UserForm onClose={onClose}/>
            </DrawerBody>
        </>
    )
}

export default NewUser;
